import React from "react";
import PathPickProductCard from "@/features/pathpick/components/product/PathPickProductCard";
import {
  PathPickMarketPriceBasis,
  PathPickProduct,
} from "@/features/pathpick/types";

interface ProductListItemCardProps {
  item: PathPickProduct;
  isSelected: boolean;
  // 부모는 identity가 고정된 핸들러를 넘겨야 한다(아래 memo 경계가 유지되는 조건).
  onToggleSelect: (item: PathPickProduct) => void;
  onOpenSizeStock: (item: PathPickProduct) => void;
  onPick: (item: PathPickProduct) => void;
  onOrder: (item: PathPickProduct) => void;
  marketPriceBasis: PathPickMarketPriceBasis;
  // 카드가 인자를 담아 호출하므로 클로저를 만들지 않고 그대로 넘긴다(memo 경계 유지).
  onOpenRequestDetail: (params: { requestId: number; sku: string }) => void;
}

// 상품 찾기 그리드의 카드 1장 — 선택·조회 상태가 바뀔 때 목록 전체가 리렌더되지 않도록 memo 경계를 만든다.
// 카드에 넘기는 0-arg 클로저를 부모가 아니라 이 안에서 만드는 것이 핵심이다.
const PathPickSearchProductsProductListItemCard = ({
  item,
  isSelected,
  onToggleSelect,
  onOpenSizeStock,
  onPick,
  onOrder,
  marketPriceBasis,
  onOpenRequestDetail,
}: ProductListItemCardProps) => {
  return (
    <PathPickProductCard
      item={item}
      marketPriceBasis={marketPriceBasis}
      isPicked={item.isInBasket}
      isSelected={isSelected}
      onToggleSelect={() => onToggleSelect(item)}
      onOpenSizeStock={() => onOpenSizeStock(item)}
      onPick={() => onPick(item)}
      onOrder={() => onOrder(item)}
      onOpenRequestDetail={onOpenRequestDetail}
    />
  );
};

export default React.memo(PathPickSearchProductsProductListItemCard);
